// Occupations.ts
import { IOccupations } from '../../UI/Components/Occupations/occupations-types';
import { IDropdownItem } from '../../UI/Components/Dropdown/Dropdown';
import { Occupations as PROD_OCCUPATIONS } from './occupations.prod';
import { Occupations as UAT_OCCUPATIONS } from './occupations.uat';

export const mapOccupationsToArray = (
    occupations: IOccupations,
    lang: string
): IDropdownItem[] => Object.entries(occupations).map(([id, o]) => ({
    id: Number(id),
    key: o.KEY,
    label: lang === 'fr' ? o.FR : o.EN,
    description: lang === 'fr' ? o.FR : o.EN,
    value: o.EN
}));

export const getOccupations = (lang: string): IDropdownItem[] => {
    const env = process.env.REACT_APP_ENV?.toLowerCase();
    const source = env === 'prod' ? PROD_OCCUPATIONS : UAT_OCCUPATIONS;
    return mapOccupationsToArray(source, lang);
};
